import { isPresent } from 'src/providers/common-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from './globals';
import { Injectable } from '@angular/core';

import { Subscriber, throwError } from 'rxjs';
import { RemoteRequest } from './remote-request';
import { AuthenticationService } from './authentication-service';
import { RemoteResponse } from './RemoteResponse';
import { Observable } from 'rxjs';
// import {ErrorObservable} from 'rxjs';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/throw';
import { ConnectionService } from './providers/connection-service/connection-service';
import { DeviceService } from './providers/device-service/device-service';
import { DeviceInfo } from './data/device-info';
import { SessionInfo } from './data/authentication-info';
import { SessionDataService } from './redux/session/session-data-service';
import { ToastController, Platform } from '@ionic/angular';
import { MessageDisplayUtil } from './message-display-utils';
import { map, catchError, distinctUntilChanged } from 'rxjs/operators';
import { AnyFn } from '@ngrx/store/src/selector';

/**
 * Created by Ashok on 30-03-2016.
 */
@Injectable()
export class RemoteHttpService {
  private root: string;
  private session: SessionInfo;
  constructor(
    // private http: Http,
    // private authService: AuthenticationService,
    private sessionService: SessionDataService,
    private connService: ConnectionService,
    private deviceService: DeviceService,
    private toastCtl: ToastController,
    private platform: Platform,
    // protected https: HttpClient
    protected http: HttpClient
  ) {
    this.root = globals.MygolfServer;
    this.sessionService
      .getSession()
      .pipe(distinctUntilChanged())
      .subscribe((session: SessionInfo) => {
        this.session = session;
      });
  }

  /**
   * Ajax call
   * @param request The RemoteRequest which encapsulates all the remote call params
   * @param subscriber The subscriber to be called once the remote request returns
   * @param params Optional parameters. Usually this is used by the caller to identify
   * the the response. This params is returned along with the Response to identify
   * for which the response is returned
   */
  public call(request: RemoteRequest, subscriber?: Subscriber<RemoteResponse>, params?: any) {
    this.execute(request).subscribe(
      (resp: any) => {
        if (isPresent(subscriber) && isPresent(subscriber.next)) {
          subscriber.next(new RemoteResponse(resp, params));
        }
      },
      (error: any) => {
        if (subscriber && subscriber.error) {
          subscriber.error(error);
        }
      },
      () => {
        //The request completed. Any cleanup, you can do it here
        if (subscriber && subscriber.complete) {
          subscriber.complete();
        }
      }
    );
  }

  public execute(
    request: any,
    url?: string,
    latitude?: number,
    longitude?: number
  ): Observable<any> {
    if (url) {
      // alert(url)
    }

    // DEBUG: Log request details
    // console.log('[DEBUG RemoteHttpService.execute] Request method:', request.method);
    // console.log('[DEBUG] Request data type:', typeof request.data);
    // console.log('[DEBUG] Request data is FormData:', request.data instanceof FormData);

    // Check if we need to bypass CapacitorHttp for FormData
    const isCapacitor = this.platform.is('capacitor');
    const isFormDataRequest = request.data instanceof FormData;
    const useNativeFetch = isCapacitor && isFormDataRequest;

    // console.log('[DEBUG] Is Capacitor:', isCapacitor);
    // console.log('[DEBUG] Is FormData request:', isFormDataRequest);
    // console.log('[DEBUG] Using native fetch:', useNativeFetch);

    let hdrs = {};
    if (isPresent(this.session)) {
      hdrs[globals.AUTH_TOKEN_NAME] = this.session.authToken;
      // hdrs["username"] = session.username;
      if (request.headers && request.headers['Player-Id']) {
      } else {
        hdrs['Player-Id'] = this.session.playerId;
      }
      // hdrs["Player-Id"]             = this.session.playerId;
    }
    this.populateDeviceInfo(hdrs);
    if (latitude && longitude) {
      hdrs['Location-Latitude'] = latitude;
      hdrs['Location-Longitude'] = longitude;
    }
    // hdrs['Referer'] = 'http://devlet.mygolf2u.com'
    let req: any = request.buildAjax(hdrs);
    let headers = new HttpHeaders();
    if (req.headers) {
      req.headers.map(data => {
        if (data.value) {
          headers = headers.append(data.key.toString(), data.value.toString());
        }
      });
    }

    // DEBUG: Log built request
    // console.log('[DEBUG] Built request URL:', req.url);
    // console.log('[DEBUG] Built request headers:', req.headers);
    // console.log('[DEBUG] Built request body type:', typeof req.body);
    // console.log('[DEBUG] Built request body is FormData:', req.body instanceof FormData);
    // console.log('[DEBUG] Content-Type header:', headers.get('Content-Type'));

    let observable;

    // Use native fetch for FormData requests on Capacitor to bypass CapacitorHttp
    if (useNativeFetch) {
      console.log('[DEBUG] Using native fetch to bypass CapacitorHttp for FormData');
      observable = new Observable(observer => {
        const fetchHeaders: Record<string, string> = {};
        headers.keys().forEach(key => {
          const value = headers.get(key);
          if (value) {
            fetchHeaders[key] = value;
          }
        });

        // Note: Don't set Content-Type for FormData - let browser set it with boundary
        delete fetchHeaders['Content-Type'];

        fetch(req.url, {
          method: request.method,
          headers: fetchHeaders,
          body: req.body,
        })
          .then(async response => {
            console.log('[DEBUG] Native fetch response status:', response.status);
            const contentType = response.headers.get('content-type');
            let data: any;

            if (contentType && contentType.includes('application/json')) {
              data = await response.json();
            } else {
              data = await response.text();
            }

            if (response.ok) {
              observer.next(data);
              observer.complete();
            } else {
              const error = {
                status: response.status,
                message: response.statusText,
                error: data,
              };
              observer.error(error);
            }
          })
          .catch(error => {
            console.error('[DEBUG] Native fetch error:', error);
            observer.error(error);
          });
      });
    } else if (url) {
      observable = this.http.delete(url, req);
    } else {
      if (req.url.indexOf('book-a-slot') > 0 || req.url.indexOf('/generate-booking-bill') >= 0) {
        observable = this.http.request(request.method, req.url, {
          body: req.body,
          headers,
          responseType: 'text',
        });
      } else {
        observable = this.http.request(request.method, req.url, { body: req.body, headers });
      }
    }

    return observable;
  }

  private populateDeviceInfo(hdrs: any) {
    let deviceInfo: DeviceInfo = this.deviceService.getCachedDeviceInfo();
    if (deviceInfo) {
      hdrs['Device-Id'] = deviceInfo.deviceId;
    }
  }

  /**
   * Converts a given data object to URL form
   * @param data The data
   * @returns {string}
   */
  toParam(data: any): string {
    let list = [];
    for (let i in data) {
      list.push(encodeURI(i) + '=' + encodeURIComponent(data[i]));
    }
    return list.join('&');
  }

  isString(value: any): boolean {
    return /^[a-zA-Z]+$/.test(value);
  }

  public handleError(error) {
    let result: any;
    // if(this.isString(error)) {
    //   result = error
    //   return throwError(result);
    // }
    // if(error) MessageDisplayUtil.showErrorToast(error.status, this.platform, this.toastCtl, 5000, "bottom");
    //Check whether the error is sent as header
    if (error && error.error && error.error.errorMessage) {
      result = error.error.errorMessage;
    } else if (!error.error && error.status === 500) {
      result = 'Something wrong with the server. Please try again.'; // "Internal Server Error";
    } else {
      result = error;
    }
    // return ErrorObservable.create(result);
    return throwError(result);
  }
}
